// This file should have no expensive imports except dynamic imports. It should
// only check IF we should load the order-tracking-login widget or not.
import { WidgetAutocheck } from "@redotech/redo-storefront-widget-common/widget";
import { log } from "../monitoring/log";

export const ORDER_TRACKING_LOGIN_SELECTOR = "#redo-order-tracking-login";

export const isOrderTrackingLoginEnabled = (autocheck: WidgetAutocheck) =>
  autocheck.orderTrackingLogin?.enabled !== false;

export const initializeIfOrderTrackingLoginFound = async () => {
  const loadAndInit = async (container: HTMLElement) => {
    if (container.dataset.initialized === "true") {
      return;
    }
    try {
      const { initializeContainer } = await import("./initialize");
      initializeContainer({ container });
    } catch (error) {
      log("Error initializing order tracking login widget:", error);
    }
  };

  const scan = (parent: ParentNode) => {
    const elements = parent.querySelectorAll<HTMLElement>(
      `${ORDER_TRACKING_LOGIN_SELECTOR}:not([data-initialized="true"])`,
    );
    for (const element of elements) {
      void loadAndInit(element);
    }
  };

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const addedNode of mutation.addedNodes) {
        if (addedNode instanceof HTMLElement) {
          if (addedNode.matches(ORDER_TRACKING_LOGIN_SELECTOR)) {
            void loadAndInit(addedNode);
          }
          const nested = addedNode.querySelectorAll<HTMLElement>(
            ORDER_TRACKING_LOGIN_SELECTOR,
          );
          for (const child of nested) {
            void loadAndInit(child);
          }
        }
      }
    }
  });

  const start = () => {
    observer.observe(document.body, { childList: true, subtree: true });
    scan(document.body);
  };

  if (document.body) {
    start();
  } else {
    document.addEventListener("DOMContentLoaded", start, { once: true });
  }
};
